export default __webpack_public_path__ + "static/media/bam.d07ef7b2.png";